import React, { useState } from "react";
import InnoIcons from "InnoUI/innoicons";
import SC from "./style";
import { Tabs } from "InnoUI/components";
import theme from "theme";
import GeneralInformationForm from "../GeneralInformationForm";

const OccupantTab = (props) => {
  const {
    onClose,
    occupantdata,
    isEditing,
    fetchData,
    Projectdata,
    levelId,
    rowId,
    isInfo = false,
    setOccupant,
    isLevel = false,
    setSelectedTabb = () => {},
  } = props;

  const [selectedTab, setSelectedTab] = useState(0);

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

  const tabData = [
    { value: 0, label: `General Information` },
    // { value: 1, label: "Contact Information" },
  ];

  return (
    <div>
      <SC.DrawerTitlesContainer>
        <SC.DrawerTitles>
          {isEditing ? "Edit Occupant" : "New Occupant"}
        </SC.DrawerTitles>
        <SC.CloseIcon>
          <InnoIcons.CloseIcon onClick={onClose} />
        </SC.CloseIcon>
      </SC.DrawerTitlesContainer>

      <div style={{ marginLeft: "15px" }}>
        <Tabs
          value={selectedTab}
          label={tabData.map((tab) => tab.label) || []}
          onChange={handleTabChange}
          selectedValue={selectedTab}
        />
      </div>
      {selectedTab === 0 && (
        <div style={{ borderTop: `1px solid ${theme.colors.bordertask}` }}>
          <GeneralInformationForm
            onClose={onClose}
            occupantdata={occupantdata}
            isEditing={isEditing}
            Projectdata={Projectdata}
            levelId={levelId}
            rowId={rowId}
            fetchData={fetchData}
            isInfo={isInfo}
            setOccupant={setOccupant}
            isLevel={isLevel}
            setSelectedTabb={setSelectedTabb}
          />
        </div>
      )}
      {selectedTab === 1 && <p>Under Development</p>}
    </div>
  );
};

export default OccupantTab;
